import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcComponentsService, DetailBcLineinfos } from '../../bc-components.service';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { getDestByString, NTHDestination, getStringByDest } from 'src/app/shared/constants/flag';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';

export interface DialogData {
  referentiel: Observable<DetailBcLineinfos>;
  bcLineForm: UntypedFormGroup;
  i: number;
  titre: string;
  dBc: Date;
}

@Component({
  selector: 'app-modal-bc-line-info',
  templateUrl: './modal-bc-line-info.component.html',
  styleUrls: ['./modal-bc-line-info.component.scss'],
})

export class ModalBcLineInfoComponent implements OnInit, AfterViewChecked {

  referentiel: DetailBcLineinfos = new DetailBcLineinfos();
  referentielDefault: DetailBcLineinfos = new DetailBcLineinfos();
  minDateLiv: string = moment(new Date()).format('YYYY-MM-DD');
  bcLineForm: UntypedFormGroup;
  //public destinations = ["Commerce", "Exploitation", "Frais Généraux"];
  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              private readonly changeDetectorRef: ChangeDetectorRef,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              private bcComposantService: BcComponentsService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.bcLineForm = this.data.bcLineForm;    
    this.minDateLiv = moment(this.data.dBc).format('YYYY-MM-DD');

    this.data.referentiel.subscribe((ref: DetailBcLineinfos) => {
      this.referentielDefault = ref
      this.referentiel = Object.assign({},ref);

      // first load ssFamille by code Famille
      let sousFamilles: SsFamilleModel[]= [];
       this.referentielDefault.ssFamilles.forEach(sf => {
          if(sf.code.includes(this.bcLineForm.controls.codeFamille.value + '.')) {
            sousFamilles.push(sf)
          }
       })
       this.referentiel.ssFamilles = sousFamilles;

        // first load categorie by code ssFamille
      let categories: CategorieModel[]= [];
      this.referentielDefault.categories.forEach(c => {
         if(c.code.includes(this.bcLineForm.controls.codeSsFamille.value + '.')) {
          categories.push(c)
         }
      })
      this.referentiel.categories = categories;

    });

    if (this.bcLineForm.controls.codeNa.value) {
      this.bcComposantService.loadCa2(this.data.i, this.bcLineForm.controls.codeCa1.value, this.bcLineForm.controls.codeNa.value);
    }
    if (this.bcLineForm.controls.codeNa.value) {
      this.bcComposantService.loadComp(this.data.i, this.bcLineForm.controls.codeNa.value,
      this.bcLineForm.controls.libelleNa.value);
    }
    if(this.bcLineForm.controls.codeCa1.value){
      this.bcComposantService.loadDestination(this.data.i,  this.bcLineForm)
    }
    if(this.bcLineForm.controls.codeCategorie.value){
      this.bcComposantService.setLibelleCategorie(this.bcLineForm);
    }    
    
  }

  getString(dest: NTHDestination): string{
    return getStringByDest(dest);
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    if (this.bcLineForm.valid) {
      this.dialogRef.close(this.bcLineForm);
    }
    if (!this.bcLineForm.controls.codeCa2.valid) {
      this.bcComposantService.loadCa2(this.data.i, this.bcLineForm.controls.codeCa1.value, this.bcLineForm.controls.codeNa.value);
    }
    if (!this.bcLineForm.controls.codeComp.valid) {
      this.bcComposantService.loadComp(this.data.i, this.bcLineForm.controls.codeNa.value,
      this.bcLineForm.controls.libelleNa.value);
    }
    this.displayErrors();
  }

  displayErrors(): void {
    for (const bcline in this.bcLineForm.controls) {
      if (bcline) {
        this.bcLineForm.controls[bcline].markAsTouched();
      }
    }
  }
}
